"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHIPPING_STATUS_OPTIONS = void 0;
exports.SHIPPING_STATUS_OPTIONS = [
    { label: 'Picked', value: 'picked' },
    { label: 'Shipped', value: 'Shipped' },
];
